import React from "react";
import Modal from "react-modal";
import "./modal.scss";

Modal.setAppElement("#root");

const ModalComponent = (props) => {
  const { isOpen, eventHandler, text } = props;

  const style = {
    content: {
      width: "400px",
      height: "150px",
      left: "40%",
      overflow: "hidden",
    },
    overlay: {
      backgroundColor: "#0000002e",
    },
  };
  return (
    <Modal isOpen={isOpen} style={style}>
      <div className="modal_holder">
        <h4>{text}</h4>
        <div className="model_button_holder">
          <button
            onClick={() => eventHandler(false)}
            style={{ marginRight: "20px" }}
          >
            NO
          </button>
          <button onClick={() => eventHandler(true)}>YES</button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/common/modal/modal.jsx